import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import styles from './Footer.module.css';
import logo from '../../assets/fusionsip-logo.png';
import logo2 from '../../assets/halal-logo.png'

import Icon from '../icon/Icon';

import { SlSocialFacebook } from "react-icons/sl";
import { FaInstagram } from "react-icons/fa";
// import { SlSocialLinkedin } from "react-icons/sl";
// import { FaXTwitter } from "react-icons/fa6";
import { RiTiktokLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  const [hovered, setHovered] = useState(null);
    const [active, setActive] = useState("about");

    
  const handleScroll = (id) => {
    const el = document.getElementById(id);

    if (el) {
      window.scrollTo({
        top: el.offsetTop - 80, // navbar height adjust
        behavior: "smooth"
      });
    }

    setActive(id);
    // setMenuOpen(false);
  };
    return (
        <footer className={styles.footer}>
            <div className={styles.top}>
              <div className={styles.left}>
            <img src={logo} alt="logo" className={styles.log} />
            <img src={logo2} alt="logo" className={styles.log} />

              </div>
            <nav className={styles.nav}>
                <Link 
                        onClick={() => handleScroll("home")}
                            className={active === "home" ? styles.active: ""}>Home</Link>
                <Link 
                        onClick={() => handleScroll("about")}
                            className={active === "about" ? styles.active: ""}>About</Link>
                <Link 
                        onClick={() => handleScroll("flavored")}
                            className={active === "flavored" ? styles.active: ""}>Our Flavors</Link>
                <Link 
                        onClick={() => handleScroll("faqs")}
                            className={active === "faqs" ? styles.active: ""}>Faqs</Link>
            </nav>
            <div className={styles.right}>

  <div
    className={styles.iconBox}
    onMouseEnter={() => setHovered("insta")}
    onMouseLeave={() => setHovered(null)}
  >
    {hovered === "insta" ? (
      <Icon Icon={FaInstagram} link="https://www.instagram.com/fusionsip.co?igsh=c2k2cDVvaHl3em5s" />
    ) : (
      <FaInstagram size={24} color="#F2692B" onClick={() => window.open("https://www.instagram.com/fusionsip.co?igsh=c2k2cDVvaHl3em5s", "_blank")} />
    )}
  </div>

  <div
    className={styles.iconBox}
    onMouseEnter={() => setHovered("linkedin")}
    onMouseLeave={() => setHovered(null)}
  >
    {hovered === "linkedin" ? (
      <Icon Icon={RiTiktokLine} link="https://www.tiktok.com/@fusionsip?_r=1&_t=ZS-94yoIqikyBg" />
    ) : (
      <RiTiktokLine size={24} color="#F2692B" onClick={() => window.open("https://www.tiktok.com/@fusionsip?_r=1&_t=ZS-94yoIqikyBg", "_blank")} />
    )}
  </div>

  <div
    className={styles.iconBox}
    onMouseEnter={() => setHovered("facebook")}
    onMouseLeave={() => setHovered(null)}
  >
    {hovered === "facebook" ? (
      <Icon Icon={SlSocialFacebook} link="https://www.facebook.com/share/1FcMPbksVV/" />
    ) : (
      <SlSocialFacebook size={24} color="#F2692B" onClick={() => window.open("https://www.facebook.com/share/1FcMPbksVV/", "_blank")} />
    )}
  </div>

  <div
    className={styles.iconBox}
    onMouseEnter={() => setHovered("twitter")}
    onMouseLeave={() => setHovered(null)}
  >
    {hovered === "twitter" ? (
      <Icon Icon={FaWhatsapp} link="https://wa.me/message/7EWJGA4ZUKBTE1" />
    ) : (
      <FaWhatsapp size={24} color="#F2692B" onClick={() => window.open("https://wa.me/message/7EWJGA4ZUKBTE1", "_blank")} />
    )}
  </div>

</div>
</div>
<hr className={styles.line} />
<p>© Copyright by Fusionsip. All rights reserved.</p>
        </footer>
    )
}

export default Footer;